import { XMarkIcon } from '@heroicons/react/24/outline';

import { Tag } from '../Tag/Tag';

interface IDisplayTag {
  id: string;
  tag: string;
  tag_name: string;
  color_hex: string;
}

type TagDisplayProps = {
  tags?: IDisplayTag[] | null;
  onDelete?: (tagId: string) => Promise<unknown>;
};

export function TagDisplay({
  tags,
  onDelete,
}: TagDisplayProps): JSX.Element | null {
  if (!tags) {
    return null;
  }

  return (
    <div className="flex flex-wrap">
      {tags.map((tag) => {
        return (
          <div className="m-1" key={tag.id}>
            <Tag
              color={tag.color_hex}
              label={tag.tag_name}
              icon={
                onDelete ? (
                  <XMarkIcon
                    className="h-4 w-4 cursor-pointer"
                    data-testid={`delete-tag-${tag.id}`}
                  />
                ) : undefined
              }
              onClick={onDelete ? () => onDelete(tag.id) : undefined}
            />
          </div>
        );
      })}
    </div>
  );
}
